import type { ProductLine } from '../data';

export function CustomerMark({ name, size = 18 }: { name: string; size?: number }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
      <div
        style={{
          width: size * 1.6,
          height: size * 1.6,
          borderRadius: size * 0.4,
          background: 'linear-gradient(150deg, #3D6AFE, #0639BA)',
          display: 'grid',
          placeItems: 'center',
          color: '#fff',
          fontFamily: 'var(--mb-font-display)',
          fontWeight: 700,
          fontSize: size * 0.85,
        }}
      >
        {name[0]}
      </div>
      <span
        style={{
          fontFamily: 'var(--mb-font-display)',
          fontWeight: 700,
          fontSize: size,
          letterSpacing: '-0.01em',
          color: 'var(--mb-slate-900)',
        }}
      >
        {name}
      </span>
    </div>
  );
}

export function LinePill({ line }: { line: ProductLine }) {
  const isSales = line === 'sales';
  return (
    <span
      style={{
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        padding: '5px 11px',
        borderRadius: 999,
        color: isSales ? 'var(--mb-blue-700)' : 'var(--mb-mint-600)',
        background: isSales ? 'var(--mb-blue-50)' : 'var(--mb-mint-100)',
      }}
    >
      {isSales ? 'Sales' : 'Marketing'}
    </span>
  );
}

export function Avatar({
  initials,
  src,
  alt,
  size = 48,
  dark = false,
}: {
  initials: string;
  /** Optional headshot URL (e.g. assets.marketbetter.ai/...). Falls back to initials. */
  src?: string;
  alt?: string;
  size?: number;
  dark?: boolean;
}) {
  if (src) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={src}
        alt={alt ?? initials}
        width={size}
        height={size}
        loading='lazy'
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          flexShrink: 0,
          objectFit: 'cover',
          border: dark ? '1px solid rgba(255,255,255,.18)' : '1px solid var(--mb-border)',
        }}
      />
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        background: dark ? 'rgba(255,255,255,.14)' : 'var(--mb-slate-100)',
        color: dark ? '#fff' : 'var(--mb-slate-600)',
        display: 'grid',
        placeItems: 'center',
        fontFamily: 'var(--mb-font-body)',
        fontWeight: 600,
        fontSize: size * 0.34,
        border: dark ? '1px solid rgba(255,255,255,.18)' : '1px solid var(--mb-border)',
      }}
    >
      {initials}
    </div>
  );
}
